import {
    SUBJECT_LIST_REQUEST, SUBJECT_LIST_SUCCESS, SUBJECT_LIST_FAIL,
    SUBJECT_DETAILS_REQUEST, SUBJECT_DETAILS_SUCCESS, SUBJECT_DETAILS_FAIL, SUBJECT_DETAILS_RESET,
    SUBJECT_CREATE_REQUEST, SUBJECT_CREATE_SUCCESS, SUBJECT_CREATE_FAIL, SUBJECT_CREATE_RESET,
    SUBJECT_UPDATE_REQUEST, SUBJECT_UPDATE_SUCCESS, SUBJECT_UPDATE_FAIL, SUBJECT_UPDATE_RESET,
    SUBJECT_DELETE_REQUEST, SUBJECT_DELETE_SUCCESS, SUBJECT_DELETE_FAIL,
    SUBJECT_DTO_REQUEST, SUBJECT_DTO_SUCCESS, SUBJECT_DTO_FAIL, SUBJECT_DTO_RESET,
    SUBJECT_LIST_BY_IDS_REQUEST, SUBJECT_LIST_BY_IDS_SUCCESS, 
    SUBJECT_LIST_BY_IDS_FAIL, SUBJECT_LIST_BY_IDS_RESET,
} from '../constants/subjectConstants';

export const subjectListReducer = (state = { subjects: [] }, action) => {
    switch (action.type) {
        case SUBJECT_LIST_REQUEST:
            return { loading: true, subjects: [] };
        case SUBJECT_LIST_SUCCESS:
            return {
                loading: false,
                subjects: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
                statistics: action.payload.statistics,
            };
        case SUBJECT_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const subjectDetailsReducer = (state = { subjects: {}, loading: false }, action) => {
    switch (action.type) {
        case SUBJECT_DETAILS_REQUEST:
            return { ...state, loading: true };
        case SUBJECT_DETAILS_SUCCESS:
            return { 
                ...state, 
                loading: false, 
                subjects: {
                    ...state.subjects,
                    [action.payload.id]: action.payload
                }
            };
        case SUBJECT_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case SUBJECT_DETAILS_RESET:
            return { subjects: {}, loading: false };
        default:
            return state;
    }
};

export const subjectDtoReducer = (state = { subjectDto: {} }, action) => {
    switch (action.type) {
        case SUBJECT_DTO_REQUEST:
            return { loading: true, subjectDto: {} };
        case SUBJECT_DTO_SUCCESS:
            return { loading: false, subjectDto: action.payload };
        case SUBJECT_DTO_FAIL:
            return { loading: false, error: action.payload };
        case SUBJECT_DTO_RESET:
            return { subjectDto: {} };
        default:
            return state;
    }
};

export const subjectDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case SUBJECT_DELETE_REQUEST:
            return { loading: true };
        case SUBJECT_DELETE_SUCCESS:
            return { loading: false, success: true };
        case SUBJECT_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const subjectCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case SUBJECT_CREATE_REQUEST:
            return { loading: true };
        case SUBJECT_CREATE_SUCCESS:
            return { loading: false, success: true, subject: action.payload };
        case SUBJECT_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case SUBJECT_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const subjectUpdateReducer = (state = { subject: {} }, action) => {
    switch (action.type) {
        case SUBJECT_UPDATE_REQUEST:
            return { loading: true };
        case SUBJECT_UPDATE_SUCCESS:
            return { loading: false, success: true, subject: action.payload };
        case SUBJECT_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case SUBJECT_UPDATE_RESET:
            return { subject: {} };
        default:
            return state;
    }
};

export const subjectListByIdsReducer = (state = { subjects: [] }, action) => {
    switch (action.type) {
        case SUBJECT_LIST_BY_IDS_REQUEST:
            return { loading: true, subjects: [] };
        case SUBJECT_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                subjects: action.payload,
            };
        case SUBJECT_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        case SUBJECT_LIST_BY_IDS_RESET:
            return { subjects: [] };
        default:
            return state;
    }
}; 